import { Component, ChangeDetectionStrategy, forwardRef, inject, output, OnInit, input } from '@angular/core';
import { ScrollPickerDirective } from '@cue/utilities';
import { DatePickerModule, DateTimePickerModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  ControlContainer,
  FormControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { FloatingLabelComponent } from '@progress/kendo-angular-label';

@Component({
  selector: 'assist-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePickerModule,
    DateTimePickerModule,
    TranslocoPipe,
    ReactiveFormsModule,
    ScrollPickerDirective,
    TimePickerModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true,
    },
  ],
})
export class DatepickerComponent implements ControlValueAccessor, OnInit {
  public floatingLabel = inject(FloatingLabelComponent, { optional: true });
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  private _ignoreEmit: boolean = false;
  onChange: any = (val) => {};
  onTouch: any = (val) => {};
  _control = new FormControl<Date>(null);
  translation = translation;

  format = input<string>('MM/dd/yyyy');
  min = input<Date>();
  appendTo = input<'root' | 'component'>('component');
  onBlur = output<void>();
  max = input<Date>();
  ngOnInit() {
    this._control.valueChanges.subscribe((val) => {
      if (this._ignoreEmit) {
        this._ignoreEmit = false;
      } else {
        this.onChange(val);
      }
    });
  }

  focus() {
    this.onTouch();
    if (this.floatingLabel) {
      this.floatingLabel.focused = true;
    }
  }

  blur() {
    this.onBlur.emit();
    if (this.floatingLabel) {
      this.floatingLabel.focused = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this._ignoreEmit = true;
    this._control.setValue(obj);
  }
}
